/**
 * Where the 2610 email gate posts, and why it differs from 2510.
 *
 * 2510 still drives the third-party DTA widget, which needs no credential from
 * this backend: its gate calls `${REACT_APP_API_BASE_URL}/...` cross-origin purely
 * to register the address, and it keeps doing exactly that. Nothing here changes
 * for it.
 *
 * 2610 is different because passing the gate now MINTS A CREDENTIAL — an HttpOnly,
 * Secure, SameSite=Lax cookie the chat routes require. A `Set-Cookie` carrying a
 * Lax cookie on a cross-site response is discarded by the browser without warning,
 * so if 2610 called the API on its own origin the visitor would complete the modal,
 * see the chat open, and get 401 on every message with nothing on screen to explain
 * it.
 *
 * Same-origin is arranged by the reverse proxy rather than by moving the backend:
 * nginx serves /chat, /send-verification and /verify-email from the portal's own
 * origin (devops/templates/10-chat-proxy.conf.template), and setupProxy.js does the
 * same in development. Hence the empty default: a relative URL is the point, and an
 * absolute one would silently reintroduce the cross-site problem.
 */

export const GATE_BASE_URL =
  process.env.REACT_APP_CHAT_BASE_URL !== undefined
    ? process.env.REACT_APP_CHAT_BASE_URL
    : '';

/** Shared fetch options for the two gate calls that set or rely on the cookie. */
export const gateFetchOptions = {
  // Same-origin already sends and stores cookies, but stating it means a future
  // change of base URL fails loudly instead of silently dropping the credential.
  credentials: 'include',
  cache: 'no-store',
};
